import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const zabiegiService = {
    getZabiegiList,
    insertZabieg,
    updateZabieg,
    getZabiegDetails,
    insertPodtyp,
    getKategorieZabiegow,
    insertKategoria,
    updateKategoria,
    deleteKategoria
};
function getZabiegiList() {
    return axios.get('/api/services/app/Zabiegi/GetZabiegiList', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function insertZabieg(data) {
    return axios.post('/api/services/app/Zabiegi/InsertZabieg',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateZabieg(data) {
    return axios.put('/api/services/app/Zabiegi/UpdateZabieg',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getZabiegDetails(id) {
    return axios.get('/api/services/app/Zabiegi/GetZabiegDetails', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function insertPodtyp(data) {
    return axios.post('/api/services/app/Zabiegi/InsertPodtyp',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getKategorieZabiegow()
{
    return axios.get('/api/services/app/Zabiegi/GetKategorieZabiegow', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function insertKategoria(data)
{
    return axios.post('/api/services/app/Zabiegi/InsertKategoria',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateKategoria(data)
{
    return axios.put('/api/services/app/Zabiegi/UpdateKategoria',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function deleteKategoria(id)
{
    return axios.delete('/api/services/app/Zabiegi/DeleteKategoriaZabiegu', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}